
const moyenneValueGetter = (params) => {
  let competences = params.data.resultats?.competences;
  let total = 0;
  competences?.forEach((comp) => (total += Number(comp.score_percent)));
  let nbItems = competences?.length ? competences?.length : 1;
  return Math.round(total / nbItems) ? Math.round(total / nbItems) : null;
};

export default moyenneValueGetter;